import { request } from "../request";
const mock = "";

// 获取我的分类(未登录为默认分类)
export const getCategoryList = (params) =>
  request(`${mock}/v1/category/list`, "get", { params });
//分类树
export const getCategoryTree = (params) =>
  request(`${mock}/v1/category/tree`, "get", { params });
// 保存我的分类
export const saveCategory = (params) =>
  request(`${mock}/v1/category/save`, "post", { json: params });
